import { HIWHeading } from './styledComponents'

export default function Heading({ heading }) {
  return <HIWHeading style={{ alignSelf: 'flex-start' }}>{heading}</HIWHeading>
}
